{
    "StatusNotReceived": "Le statut reçu n'était pas OK.",
    "NAME": "LanguageFallbackNav"
}